'use strict'

// import Vue from 'vue'

import ConfigModel from './ConfigModel.js'

let Configs = new ConfigModel()

import getInstall from './js/getInstall.js'

const install = getInstall(Configs)

const exportDefault = {
  Configs,
  install,
}

export { Configs, install }
export default exportDefault
